// Group IV. 語態與補語 Voice and Complements
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group4Data = {
  id: "group_4",
  title: {
    tc: "語態與補語",
    sc: "语态与补语",
    en: "Voice and Complements"
  },
  subtitle: {
    tc: "Voice and Complements",
    sc: "Voice and Complements",
    en: "Voice and Complements"
  },
  icon: "🔄",
  difficulty: "intermediate",
  color: "from-orange-500 to-orange-600",
  topics: [
    {
      id: "passive_voice",
      title: {
        tc: "被動語態",
        sc: "被动语态",
        en: "Passive Voice"
      },
      description: {
        tc: "學習被動語態的構成和使用",
        sc: "学习被动语态的构成和使用",
        en: "Learn the formation and usage of the passive voice"
      },
      icon: "🔄",
      difficulty: "intermediate",
      examples: [
        {
          id: "passive_1",
          sentence: "The window was broken by the wind.",
          analysis: "The window (S) was broken (V-pass) by the wind (M-agent).",
          translation: {
            tc: "窗戶被風打破了。",
            sc: "窗户被风打破了。",
            en: "The window was broken by the wind."
          }
        },
        {
          id: "passive_2",
          sentence: "The report will be published tomorrow.",
          analysis: "The report (S) will be published (V-pass) tomorrow (M).",
          translation: {
            tc: "報告將於明天發表。",
            sc: "报告将于明天发表。",
            en: "The report will be published tomorrow."
          }
        },
        {
          id: "passive_3",
          sentence: "He was given a prize.",
          analysis: "He (S) was given (V-pass) a prize (O).",
          translation: {
            tc: "他被授予了一個獎項。",
            sc: "他被授予了一个奖项。",
            en: "He was given a prize."
          }
        },
        {
          id: "passive_4",
          sentence: "Several roads have been closed.",
          analysis: "Several roads (S) have been closed (V-pass).",
          translation: {
            tc: "幾條道路已被關閉。",
            sc: "几条道路已被关闭。",
            en: "Several roads have been closed."
          }
        },
        {
          id: "passive_5",
          sentence: "Mistakes were made.",
          analysis: "Mistakes (S) were made (V-pass).",
          translation: {
            tc: "犯了錯誤。",
            sc: "犯了错误。",
            en: "Mistakes were made."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：be + 過分；可省略施事；雙受詞動詞可轉被動兩種。",
        sc: "要点：be + 过分；可省略施事；双受词动词可转被动两种。",
        en: "Key points: be + past participle; agent can be omitted; ditransitive verbs can have two passive forms."
      }
    },
    {
      id: "linking_verbs",
      title: {
        tc: "連綴動詞",
        sc: "连缀动词",
        en: "Linking Verbs (S–V–C)"
      },
      description: {
        tc: "學習連綴動詞的用法和結構",
        sc: "学习连缀动词的用法和结构",
        en: "Learn the usage and structure of linking verbs"
      },
      icon: "🔗",
      difficulty: "intermediate",
      examples: [
        {
          id: "linking_1",
          sentence: "The soup smells good.",
          analysis: "The soup (S) smells (V-link) good (C).",
          translation: {
            tc: "這湯聞起來很香。",
            sc: "这汤闻起来很香。",
            en: "The soup smells good."
          }
        },
        {
          id: "linking_2",
          sentence: "She became a lawyer.",
          analysis: "She (S) became (V-link) a lawyer (C).",
          translation: {
            tc: "她成為了一名律師。",
            sc: "她成为了一名律师。",
            en: "She became a lawyer."
          }
        },
        {
          id: "linking_3",
          sentence: "He looks tired.",
          analysis: "He (S) looks (V-link) tired (C).",
          translation: {
            tc: "他看起來很累。",
            sc: "他看起来很累。",
            en: "He looks tired."
          }
        },
        {
          id: "linking_4",
          sentence: "The plan seems feasible.",
          analysis: "The plan (S) seems (V-link) feasible (C).",
          translation: {
            tc: "這個計劃似乎可行。",
            sc: "这个计划似乎可行。",
            en: "The plan seems feasible."
          }
        },
        {
          id: "linking_5",
          sentence: "The room grew silent.",
          analysis: "The room (S) grew (V-link) silent (C).",
          translation: {
            tc: "房間變得安靜了。",
            sc: "房间变得安静了。",
            en: "The room grew silent."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：連綴動詞後接表語（名詞/形容詞）；不可直接帶 O。",
        sc: "要点：连缀动词后接表语（名词/形容词）；不可直接带 O。",
        en: "Key points: linking verbs are followed by complements (nouns/adjectives); cannot directly take objects."
      }
    },
    {
      id: "object_complement_active",
      title: {
        tc: "受詞補語（主動）",
        sc: "受词补语（主动）",
        en: "Object Complement (Active)"
      },
      description: {
        tc: "學習主動語態中的受詞補語結構",
        sc: "学习主动语态中的受词补语结构",
        en: "Learn object complement structures in active voice"
      },
      icon: "🎯",
      difficulty: "intermediate",
      examples: [
        {
          id: "oc_active_1",
          sentence: "They elected her president.",
          analysis: "They (S) elected (V) her (O) president (C-OC).",
          translation: {
            tc: "他們選她為總統。",
            sc: "他们选她为总统。",
            en: "They elected her president."
          }
        },
        {
          id: "oc_active_2",
          sentence: "The joke made him angry.",
          analysis: "The joke (S) made (V) him (O) angry (C-OC).",
          translation: {
            tc: "這個笑話讓他生氣了。",
            sc: "这个笑话让他生气了。",
            en: "The joke made him angry."
          }
        },
        {
          id: "oc_active_3",
          sentence: "We painted the wall blue.",
          analysis: "We (S) painted (V) the wall (O) blue (C-OC).",
          translation: {
            tc: "我們把牆漆成藍色。",
            sc: "我们把墙漆成蓝色。",
            en: "We painted the wall blue."
          }
        },
        {
          id: "oc_active_4",
          sentence: "She found the room empty.",
          analysis: "She (S) found (V) the room (O) empty (C-OC).",
          translation: {
            tc: "她發現房間是空的。",
            sc: "她发现房间是空的。",
            en: "She found the room empty."
          }
        },
        {
          id: "oc_active_5",
          sentence: "The news drove them crazy.",
          analysis: "The news (S) drove (V) them (O) crazy (C-OC).",
          translation: {
            tc: "這個消息讓他們瘋狂了。",
            sc: "这个消息让他们疯狂了。",
            en: "The news drove them crazy."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：V + O + C，C 說明 O 的狀態/身分。",
        sc: "要点：V + O + C，C 说明 O 的状态/身份。",
        en: "Key points: V + O + C, where C describes the state/identity of O."
      }
    },
    {
      id: "causative_sensory_oc",
      title: {
        tc: "受詞補語（使役/感官）",
        sc: "受词补语（使役/感官）",
        en: "Causative/Sensory OC"
      },
      description: {
        tc: "學習使役和感官動詞的受詞補語結構",
        sc: "学习使役和感官动词的受词补语结构",
        en: "Learn object complement structures with causative and sensory verbs"
      },
      icon: "👁️",
      difficulty: "intermediate",
      examples: [
        {
          id: "causative_1",
          sentence: "I saw him running.",
          analysis: "I (S) saw (V) him (O) running (C-OC).",
          translation: {
            tc: "我看見他在跑步。",
            sc: "我看见他在跑步。",
            en: "I saw him running."
          }
        },
        {
          id: "causative_2",
          sentence: "I heard the baby cry.",
          analysis: "I (S) heard (V) the baby (O) cry (C-OC).",
          translation: {
            tc: "我聽見嬰兒在哭。",
            sc: "我听见婴儿在哭。",
            en: "I heard the baby cry."
          }
        },
        {
          id: "causative_3",
          sentence: "She made me wait.",
          analysis: "She (S) made (V) me (O) wait (C-OC).",
          translation: {
            tc: "她讓我等待。",
            sc: "她让我等待。",
            en: "She made me wait."
          }
        },
        {
          id: "causative_4",
          sentence: "Let him go.",
          analysis: "(You) (S) let (V) him (O) go (C-OC).",
          translation: {
            tc: "讓他走吧。",
            sc: "让他走吧。",
            en: "Let him go."
          }
        },
        {
          id: "causative_5",
          sentence: "We had the printer fixed.",
          analysis: "We (S) had (V) the printer (O) fixed (C-OC).",
          translation: {
            tc: "我們讓人修理了印表機。",
            sc: "我们让人修理了打印机。",
            en: "We had the printer fixed."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：感官動詞可接原形或分詞；使役動詞 make/let/have/get 結構需分清。",
        sc: "要点：感官动词可接原形或分词；使役动词 make/let/have/get 结构需分清。",
        en: "Key points: sensory verbs can take bare infinitive or participle; causative verbs make/let/have/get structures need to be distinguished."
      }
    },
    {
      id: "causatives_have_get",
      title: {
        tc: "使役 have/get",
        sc: "使役 have/get",
        en: "Causatives with have/get"
      },
      description: {
        tc: "學習 have/get 使役結構的用法",
        sc: "学习 have/get 使役结构的用法",
        en: "Learn the usage of causative structures with have/get"
      },
      icon: "🔧",
      difficulty: "intermediate",
      examples: [
        {
          id: "have_get_1",
          sentence: "I had my car repaired.",
          analysis: "I (S) had (V) my car (O) repaired (C-OC).",
          translation: {
            tc: "我讓人修理了我的車。",
            sc: "我让人修理了我的车。",
            en: "I had my car repaired."
          }
        },
        {
          id: "have_get_2",
          sentence: "She had her hair cut.",
          analysis: "She (S) had (V) her hair (O) cut (C-OC).",
          translation: {
            tc: "她讓人剪了她的頭髮。",
            sc: "她让人剪了她的头发。",
            en: "She had her hair cut."
          }
        },
        {
          id: "have_get_3",
          sentence: "We got the door fixed.",
          analysis: "We (S) got (V) the door (O) fixed (C-OC).",
          translation: {
            tc: "我們讓人修理了門。",
            sc: "我们让人修理了门。",
            en: "We got the door fixed."
          }
        },
        {
          id: "have_get_4",
          sentence: "He got me to help him.",
          analysis: "He (S) got (V) me (O) to help (OC) him (O2).",
          translation: {
            tc: "他讓我幫助他。",
            sc: "他让我帮助他。",
            en: "He got me to help him."
          }
        },
        {
          id: "have_get_5",
          sentence: "They had the report submitted.",
          analysis: "They (S) had (V) the report (O) submitted (C-OC).",
          translation: {
            tc: "他們讓人提交了報告。",
            sc: "他们让人提交了报告。",
            en: "They had the report submitted."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：have/get + O + V-ed/adj；get + O + to-V（使某人去做）。",
        sc: "要点：have/get + O + V-ed/adj；get + O + to-V（使某人去做）。",
        en: "Key points: have/get + O + V-ed/adj; get + O + to-V (make someone do something)."
      }
    }
  ]
};
